module.exports = __webpack_public_path__ + "img/网易新闻_04.2b1dbe66.jpg";